import { render, staticRenderFns } from "./BaseInputCircleColor.vue?vue&type=template&id=24f939d0&scoped=true&"
import script from "./BaseInputCircleColor.vue?vue&type=script&lang=ts&"
export * from "./BaseInputCircleColor.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputCircleColor.vue?vue&type=style&index=0&id=24f939d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f939d0",
  null
  
)

export default component.exports